import { NudgingSubscriptionBanner } from '@/pages/ui/nudging-subscribe-banner/nudging-subscribe-banner'

import { cn } from '@/lib/utils'

import { NoSubscriptionGraphic } from './no-subscription-graphic'

export interface NoSubscriptionProps {
  isAdmin?: boolean
  isFreeTrialAvailable?: boolean
}

export const NoSubscription = ({ isAdmin, isFreeTrialAvailable }: NoSubscriptionProps) => {
  return (
    <div
      className={cn('flex flex-col items-center', 'py-[40px]', 'rounded-[10px] border border-slate-300', 'bg-slate-50')}
    >
      <NoSubscriptionGraphic />
      <div className={cn('mt-5')}>
        <NudgingSubscriptionBanner isAdmin={isAdmin} isFreeTrialAvailable={isFreeTrialAvailable} />
      </div>
    </div>
  )
}
